import { Injectable } from '@angular/core';
import { CommonStoreService } from './common-store.service';
import { BookedAppointment } from 'src/app/models/booked-appointment.model';
import { EXPIRATION_BOOKING_APPOINTMENT_DATA } from 'src/app/constants/expiration-booking-appointment-data.const';

@Injectable({
  providedIn: 'root'
})
export class ExpiredAppointmentService {
  constructor(private commonStore: CommonStoreService) {}

  /**
   * Checks if the current booked appointment is expired.
   * If expired, resets the booked appointment in the store.
   */
  public checkAndResetBookingAppointmentIfExpired(): void {
    const appointment: BookedAppointment | null = this.commonStore.getBookedAppointmentSnapshot();
    if (!appointment || !appointment.createdAt) return;
    const createdAt = new Date(appointment.createdAt).getTime();
    const now = Date.now();

    if (now - createdAt > EXPIRATION_BOOKING_APPOINTMENT_DATA) {
      this.commonStore.resetBookedAppointment();
    }
  }
}
